import { render, staticRenderFns } from "./TyphoonReport.vue?vue&type=template&id=b501ed9c&"
import script from "./TyphoonReport.vue?vue&type=script&lang=js&"
export * from "./TyphoonReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports